import {Component, OnInit, Input} from '@angular/core';
import {RfqModalComponent} from "../rfq-modal/rfq-modal";
import { MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'rfq-btn',
    templateUrl: './rfq-btn.html',
    styleUrls: ['./rfq-btn.scss'],
    standalone: false
})
export class RfqBtnComponent implements  OnInit {

    @Input() btnText: string;
    @Input() pid: number;
    @Input() sku: string;
    @Input() skuText: string;
    @Input() dataClasses;

    constructor(public dialog: MatDialog) {
    }

    ngOnInit() {
    }

    createRfq() {
        this.dialog.open(
            RfqModalComponent,
            {data: {pid: this.pid, sku:this.sku, skuText: this.skuText},
                panelClass: 'rfq-dialog',
                width: '50%'
            });
    }
}
